import { IconProps } from "interfaces/icons";
import calculateSideByRatio from "utils/calculateSideByRatio";

const SIDES_RATIO = 1;

const EditIcon = ({ size, color }: IconProps): JSX.Element => {
	let height = 9;
	if (size) {
		height = size;
	}
	const width = calculateSideByRatio(height, SIDES_RATIO);

	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 9 9"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M0.44565 8.16698H0.499709L3.10781 7.59941C3.15861 7.59095 3.20568 7.56742 3.24293 7.53185L7.66179 3.11296C7.9846 2.79086 8.1647 2.35275 8.1618 1.89676C8.16239 1.43724 7.98289 0.995789 7.66179 0.667038C7.33972 0.344236 6.90161 0.164135 6.4456 0.167057C5.98669 0.162996 5.54651 0.34884 5.2294 0.680566L0.824011 5.09943C0.785161 5.1307 0.756838 5.17315 0.742922 5.22105L0.175381 7.82915C0.159888 7.92278 0.189995 8.01818 0.25647 8.08592C0.306364 8.13682 0.374365 8.16597 0.44565 8.16698ZM6.4456 0.707595C7.0949 0.707543 7.62129 1.23388 7.62134 1.88318C7.62134 1.88771 7.62131 1.89224 7.62126 1.89676C7.62569 2.20609 7.50365 2.50383 7.28343 2.72107L5.62129 1.0454C5.84027 0.827792 6.13687 0.706224 6.4456 0.707595ZM5.2429 1.43731L6.90505 3.09946L3.05372 6.93726L1.39158 5.28861L5.2429 1.43731ZM1.17537 5.82918L2.51318 7.16699L0.796981 7.54538L1.17537 5.82918Z"
				fill={color}
			/>
		</svg>
	);
};

export default EditIcon;
